<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1309_3358)">
      <path
        d="M10.8812 11.6861L7.95287 12.008L5.0542 11.6861C6.42531 11.6861 6.90627 10.7045 6.99995 9.40588C7.01251 9.23397 7.01798 9.05658 7.01798 8.87533V8.75268C7.32189 8.81803 7.64865 8.85312 7.99987 8.85312C8.33855 8.85312 8.65468 8.82061 8.94957 8.75976V8.87533C8.94957 9.05883 8.95472 9.23847 8.96696 9.41232C9.05581 10.7078 9.51231 11.6861 10.8812 11.6861Z"
        fill="#FAD207"
      />
      <path
        d="M11.9761 12.368V13.4567L7.96801 13.7787L3.95996 13.4567V12.368C3.95996 11.9913 4.26515 11.6861 4.64181 11.6861H11.2942C11.6017 11.6861 11.8614 11.8896 11.9464 12.169C11.9658 12.2321 11.9761 12.2988 11.9761 12.368Z"
        fill="#FAD207"
      />
      <path
        d="M11.9464 12.169H4.76479C4.58708 12.169 4.44286 12.3132 4.44286 12.4909V13.4567H3.95996V12.368C3.95996 11.9913 4.26515 11.6861 4.64181 11.6861H11.2942C11.6017 11.6861 11.8614 11.8896 11.9464 12.169Z"
        fill="#FAA515"
      />
      <path
        d="M8.967 9.41231C8.6573 9.46833 8.3328 9.49698 7.99992 9.49698C7.65545 9.49698 7.31968 9.4664 7 9.40587C7.01256 9.23396 7.01803 9.05658 7.01803 8.87533V8.75267L7.99992 8.7144L8.94962 8.75976V8.87533C8.94962 9.05883 8.95477 9.23847 8.967 9.41231Z"
        fill="#FAA515"
      />
      <path
        d="M16.0002 3.2676C16.0002 5.65505 14.0577 7.59758 11.6702 7.59758H11.0425C11.3242 7.30624 11.5659 6.97819 11.7736 6.63018C13.4183 6.58028 14.7698 5.34438 15 3.7505H12.808C12.8759 3.39992 12.9238 3.07219 12.9577 2.78471H15.5173C15.7839 2.78471 16.0002 3.00104 16.0002 3.2676Z"
        fill="#FAD207"
      />
      <path
        d="M12.5742 6.50849C12.4957 6.66463 12.4129 6.81529 12.3263 6.96016C12.1927 7.18423 12.0492 7.39541 11.8969 7.59147C11.8219 7.59565 11.7462 7.59759 11.6702 7.59759H11.0425L11.1139 7.13513L11.7736 6.63018C11.7736 6.63018 12.3183 6.57996 12.5742 6.50849Z"
        fill="#FAA515"
      />
      <path
        d="M13.6055 2.78471C13.6026 2.80949 13.5997 2.83461 13.5968 2.86004C13.5614 3.16008 13.5167 3.45915 13.4629 3.7505H12.8078L12.5698 3.2676L12.9574 2.78471H13.6055Z"
        fill="#FAA515"
      />
      <path
        d="M15.9998 3.2676C15.9998 5.57907 14.179 7.47332 11.8965 7.59147C12.0488 7.39541 12.1923 7.18422 12.3259 6.96016C12.4125 6.81529 12.4953 6.66462 12.5738 6.50849C13.8406 6.15469 14.808 5.07654 14.9996 3.7505H13.4627C13.5164 3.45915 13.5612 3.16008 13.5966 2.86004C13.5995 2.83461 13.6024 2.80949 13.6053 2.78471H15.5169C15.7835 2.78471 15.9998 3.00104 15.9998 3.2676Z"
        fill="#FAD207"
      />
      <path
        d="M4.95775 7.59758H4.32998C1.94254 7.59758 0 5.65505 0 3.2676C0 3.00104 0.216338 2.78471 0.482897 2.78471H3.04258C3.07638 3.07219 3.12435 3.39992 3.19227 3.7505H1.00024C1.23042 5.34438 2.58189 6.58028 4.22664 6.63018C4.43429 6.97819 4.67606 7.30624 4.95775 7.59758Z"
        fill="#FAD207"
      />
      <path
        d="M3.19228 3.7505H2.53715C2.48338 3.45883 2.43864 3.15976 2.40322 2.86004C2.40033 2.83461 2.39743 2.80949 2.39453 2.78471H3.04258L3.43196 3.279L3.19228 3.7505Z"
        fill="#FAA515"
      />
      <path
        d="M4.95753 7.59759H4.32977C4.25379 7.59759 4.17814 7.59565 4.10313 7.59147C3.95085 7.39541 3.80727 7.18423 3.67367 6.96016C3.58707 6.81529 3.50433 6.66463 3.42578 6.50849C3.68172 6.57996 4.22642 6.63018 4.22642 6.63018L4.82731 7.05526L4.95753 7.59759Z"
        fill="#FAA515"
      />
      <path
        d="M13.2312 13.4567H2.76837C2.41277 13.4567 2.12451 13.745 2.12451 14.1006V15.3561C2.12451 15.7117 2.41277 16 2.76837 16H13.2312C13.5868 16 13.875 15.7117 13.875 15.3561V14.1006C13.875 13.745 13.5868 13.4567 13.2312 13.4567Z"
        fill="#0F940B"
      />
      <path
        d="M3.41224 16H2.76837C2.41264 16 2.12451 15.7119 2.12451 15.3561V14.1006C2.12451 13.7449 2.41264 13.4567 2.76837 13.4567V15.3561C2.76837 15.7119 3.0565 16 3.41224 16Z"
        fill="#4CF446"
      />
      <path
        d="M13.0384 1.64185C13.0384 1.64185 13.0384 1.88652 13.0068 2.28571C12.9952 2.43251 12.9791 2.60056 12.9576 2.78471C12.9238 3.07219 12.8758 3.39992 12.8079 3.7505C12.6314 4.65545 12.3211 5.713 11.7735 6.63018C11.5659 6.97819 11.3241 7.30623 11.0424 7.59758C10.5035 8.15517 9.81906 8.58012 8.94984 8.75976C8.65495 8.8206 8.33881 8.85312 8.00014 8.85312C7.64892 8.85312 7.32215 8.81803 7.01825 8.75267C6.16449 8.56982 5.49036 8.14841 4.95789 7.59758C4.6762 7.30623 4.43443 6.97819 4.22678 6.63018C3.67918 5.713 3.36884 4.65545 3.19242 3.7505C3.12449 3.39992 3.07652 3.07219 3.04272 2.78471C3.02115 2.60056 3.00505 2.43251 2.99346 2.28571C2.96191 1.88652 2.96191 1.64185 2.96191 1.64185H13.0384Z"
        fill="#FAD207"
      />
      <path
        d="M8.16221 3.06357L8.55773 4.28089H9.8377C10.003 4.28089 10.0717 4.49236 9.93798 4.58952L8.90246 5.34188L9.29798 6.55923C9.34904 6.71643 9.16915 6.84713 9.03545 6.74997L7.99992 5.99762L6.9644 6.74997C6.8307 6.84713 6.65077 6.7164 6.70186 6.55923L7.09739 5.34188L6.06186 4.58952C5.92816 4.49236 5.99686 4.28089 6.16214 4.28089H7.44211L7.83764 3.06357C7.88876 2.90637 8.11115 2.90637 8.16221 3.06357Z"
        fill="#0F940B"
      />
      <path
        d="M10.9458 14.9859H5.05444C4.92106 14.9859 4.81299 14.8778 4.81299 14.7445C4.81299 14.6111 4.92106 14.503 5.05444 14.503H10.9458C11.0792 14.503 11.1872 14.6111 11.1872 14.7445C11.1872 14.8778 11.0792 14.9859 10.9458 14.9859Z"
        fill="#4CF446"
      />
      <path
        d="M13.0384 1.64185L7.79259 1.31992L3.60578 1.64185H2.96191C2.96191 1.64185 2.96191 1.88652 2.99346 2.28571C3.00505 2.43252 3.02115 2.60056 3.04272 2.78471C3.07652 3.07219 3.12449 3.39992 3.19242 3.7505C3.36884 4.65545 3.67918 5.713 4.22678 6.63018C4.43443 6.97819 4.6762 7.30624 4.95789 7.59758C5.49036 8.14841 6.16449 8.56982 7.01825 8.75268C7.32215 8.81803 7.64892 8.85312 8.00014 8.85312C8.1096 8.85312 8.21648 8.8499 8.32111 8.84314C8.09028 8.82833 7.87073 8.79742 7.66211 8.75268C6.80835 8.56982 6.13423 8.14841 5.60175 7.59758C5.32006 7.30624 5.07829 6.97819 4.87065 6.63018C4.32304 5.713 4.0127 4.65545 3.83628 3.7505C3.76835 3.39992 3.72038 3.07219 3.68658 2.78471C3.68636 2.78287 3.68616 2.78104 3.68594 2.7792C3.65526 2.51628 3.86142 2.28571 4.12611 2.28571H13.0068C13.0384 1.88652 13.0384 1.64185 13.0384 1.64185Z"
        fill="#FAA515"
      />
      <path
        d="M2.94544 0H13.0541C13.5075 0 13.875 0.367549 13.875 0.820925C13.875 1.2743 13.5075 1.64185 13.0541 1.64185H2.94544C2.49206 1.64185 2.12451 1.2743 2.12451 0.820925C2.12451 0.367549 2.49206 0 2.94544 0Z"
        fill="#FAD207"
      />
      <path
        d="M3.5893 1.64185H2.94544C2.49216 1.64185 2.12451 1.27421 2.12451 0.820925C2.12451 0.594286 2.21658 0.388893 2.36499 0.240483C2.51341 0.0920724 2.7188 0 2.94544 0H3.5893C3.36266 0 3.15727 0.0920724 3.00886 0.240483C2.86045 0.388893 2.76837 0.594286 2.76837 0.820925C2.76837 1.27421 3.13602 1.64185 3.5893 1.64185Z"
        fill="#FAA515"
      />
    </g>
    <defs>
      <clipPath id="clip0_1309_3358">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
